import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "row mb-20" }
const _hoisted_6 = { class: "col-md-6 d-flex align-items-center" }
const _hoisted_7 = { class: "col-md-6 d-flex align-items-center" }
const _hoisted_8 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_9 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 4,
  class: "text-nowrap"
}
const _hoisted_16 = {
  key: 5,
  class: "text-nowrap"
}
const _hoisted_17 = {
  key: 6,
  class: "text-nowrap"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 7,
  class: "text-nowrap"
}
const _hoisted_20 = {
  key: 0,
  class: "badge rounded-pill fs-13 text-bg-danger"
}
const _hoisted_21 = {
  key: 1,
  class: "badge rounded-pill fs-13 text-bg-primary"
}
const _hoisted_22 = {
  key: 2,
  class: "badge rounded-pill fs-13 text-bg-secondary"
}
const _hoisted_23 = {
  key: 3,
  class: "badge rounded-pill fs-13 text-bg-info"
}
const _hoisted_24 = {
  key: 4,
  class: "badge rounded-pill fs-13 text-bg-success"
}
const _hoisted_25 = ["onUpdate:modelValue", "onChange", "disabled"]
const _hoisted_26 = {
  key: 10,
  class: "dropdown"
}
const _hoisted_27 = { class: "dropdown-menu" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 2 }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { key: 3 }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { key: 4 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { key: 5 }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { key: 11 }
const _hoisted_43 = {
  class: "modal fade",
  id: "modal_ShowBe",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_44 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_45 = { class: "modal-content p-15 p-md-40" }
const _hoisted_46 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_47 = {
  class: "modal fade",
  id: "modal_ShowReceivedColi",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_48 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_49 = { class: "modal-content p-15 p-md-40" }
const _hoisted_50 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_51 = {
  class: "modal fade",
  id: "modal_transport",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_52 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_53 = { class: "modal-content p-15 p-md-40" }
const _hoisted_54 = { class: "modal-header" }
const _hoisted_55 = { class: "modal-title fs-5" }
const _hoisted_56 = { class: "modal-body" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-12 mb-20" }
const _hoisted_59 = {
  class: "form-group",
  label: "Choisir Transport",
  "label-for": "trans"
}
const _hoisted_60 = { class: "col-12 mb-20" }
const _hoisted_61 = {
  class: "form-group",
  "label-for": "name",
  label: "Le nombre de sacs"
}
const _hoisted_62 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_63 = {
  class: "form-group",
  "label-for": "name",
  label: "Code d\\'envoie"
}
const _hoisted_64 = { class: "modal-footer" }
const _hoisted_65 = {
  class: "modal fade",
  id: "modal_distribution",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_66 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_67 = { class: "modal-content p-15 p-md-40" }
const _hoisted_68 = { class: "modal-header" }
const _hoisted_69 = { class: "modal-title fs-5" }
const _hoisted_70 = { class: "modal-body" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col-12" }
const _hoisted_73 = {
  class: "form-group",
  label: "Auto Distribution",
  "label-for": "distr"
}
const _hoisted_74 = {
  key: 0,
  class: "col-12"
}
const _hoisted_75 = {
  class: "form-group",
  label: "Livreur",
  "label-for": "distr"
}
const _hoisted_76 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_templat = _resolveComponent("templat")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!
  const _component_ShowEditBn = _resolveComponent("ShowEditBn")!
  const _component_EditSentNote2 = _resolveComponent("EditSentNote2")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.auth.can('ADD_BE_S') && _ctx.auth.can('BE'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                to: "/add-sent-notes"
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode(" Ajouter Bon d'envoie ( SIMPLE ) ", -1),
                  _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
                ])),
                _: 1,
                __: [13]
              }))
            : _createCommentVNode("", true),
          (_ctx.auth.can('ADD_BE_G') && _ctx.auth.can('BE'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                to: "/add-global-sent"
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode(" Ajouter Bon denvoie ( GLOBAL ) ", -1),
                  _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
                ])),
                _: 1,
                __: [14]
              }))
            : _createCommentVNode("", true)
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[16] || (_cache[16] = _createElementVNode("label", null, "Voir", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.filters.per_page,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.per_page) = $event)),
              options: [10, 25, 50],
              clearable: false,
              class: "per-page-selector d-inline-block mx-50",
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getRecords()))
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, "sur " + _toDisplayString(_ctx.filters.total) + " entités", 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control shadow-none text-black rounded-0",
              placeholder: "Chercher",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter())),
              onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.searchTerm) = $event))
            }, null, 544), [
              [_vModelText, _ctx.filters.searchTerm]
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows,
          loading: _ctx.isLoader,
          "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Bons Sélectionés',
          disableSelectInfo: true,
        },
          onSelectAll: _ctx.selectNotes,
          onSelectedRowsChange: _ctx.onSelectAllNotes
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [
                _createTextVNode("Aucune entrées correspondantes trouvées", -1)
              ])),
              _: 1,
              __: [17]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'note_ref')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _createElementVNode("b", null, _toDisplayString(props.row.note_ref), 1)
                ]))
              : (props.column.field === 'created_at')
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    (props.row.created_at != null)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (props.row.userc)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(props.row.userc.name), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (props.column.field === 'sent_time')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                      (props.row.sent_time != null)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.getDate(props.row.sent_time)), 1),
                            _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1))
                          ], 64))
                        : _createCommentVNode("", true),
                      (props.row.suser)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(props.row.suser.name), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (props.column.field === 'delivery_time')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                        (props.row.delivery_time != null)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.getDate(props.row.delivery_time)) + " ", 1),
                              _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1))
                            ], 64))
                          : _createCommentVNode("", true),
                        (props.row.userd)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(props.row.userd.name), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (props.column.field === 'sending_zone_name')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                          _createElementVNode("h6", null, _toDisplayString(props.row.sending_zone_name), 1),
                          _createElementVNode("span", null, _toDisplayString(props.row.sending_agency_name), 1)
                        ]))
                      : (props.column.field === 'reception_zone_name')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                            _createElementVNode("h6", null, _toDisplayString(props.row.reception_zone_name), 1),
                            _createElementVNode("span", null, _toDisplayString(props.row.reception_agency_name), 1)
                          ]))
                        : (props.column.field === 'transport')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                              _createElementVNode("h6", null, [
                                _createTextVNode(_toDisplayString(props.row.transport) + " ", 1),
                                (props.row.transport && props.row.transport_code)
                                  ? (_openBlock(), _createBlock(_component_templat, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("(" + _toDisplayString(props.row.transport_code) + ")", 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              (props.row.transport && props.row.transport_sacs)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_18, _toDisplayString(props.row.transport_sacs) + " Sacs", 1))
                                : _createCommentVNode("", true)
                            ]))
                          : (props.column.field === 'delivered')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(props.row.scanned), 1))
                            : (props.column.field === 'sent')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                  (props.row.sent == 0 && props.row.delivered == 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, " Attente d'expédition "))
                                    : (props.row.sent == 0 && props.row.delivered == 4)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, " Hors Zone "))
                                      : _createCommentVNode("", true),
                                  (props.row.sent == 0 && props.row.delivered == 3)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, " Auto Ajout "))
                                    : (props.row.sent == 1 && props.row.delivered == 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Expédié "))
                                      : _createCommentVNode("", true),
                                  (
                props.row.delivered == 1 &&
                (props.row.sent == 1 ||
                  (props.row.sent == 0 &&
                    props.row.reception_agency == props.row.sending_agency))
              )
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Reçu "))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (props.column.field === 'recu')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                    (props.row.sent == 1)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (_ctx.auth.can('BE') && _ctx.auth.can('RECEIVE_BE'))
                                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                key: 0,
                                                type: "checkbox",
                                                "onUpdate:modelValue": ($event: any) => ((props.row.recieved) = $event),
                                                class: "custom-control-success",
                                                name: "check-button",
                                                switch: "",
                                                onChange: ($event: any) => (_ctx.recevedNote(props.row)),
                                                value: "1",
                                                "unchecked-value": "0",
                                                indeterminate: false,
                                                disabled: 
                  props.row.delivered == 1 &&
                  (props.row.sent == 1 ||
                    (props.row.sent == 0 &&
                      props.row.reception_agency == props.row.sending_agency))
                
                                              }, null, 40, _hoisted_25)), [
                                                [_vModelCheckbox, props.row.recieved]
                                              ])
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (props.column.field === 'action')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                      _cache[29] || (_cache[29] = _createElementVNode("button", {
                                        class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                                        type: "button",
                                        "data-bs-toggle": "dropdown",
                                        "aria-expanded": "false"
                                      }, [
                                        _createElementVNode("i", { class: "flaticon-dots" })
                                      ], -1)),
                                      _createElementVNode("ul", _hoisted_27, [
                                        (
                    _ctx.auth.can('BE') &&
                    props.row.parcels_num != 0 &&
                    props.row.sent == 0 &&
                    (props.row.delivered == 3 || props.row.delivered == 4) &&
                    props.row.reception_agency != props.row.sending_agency
                  )
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                                              _createElementVNode("button", {
                                                class: "dropdown-item d-flex align-items-center",
                                                onClick: ($event: any) => (_ctx.toExpedition(props.row))
                                              }, _cache[20] || (_cache[20] = [
                                                _createElementVNode("i", { class: "flaticon-telegram lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Vers Expédition ", -1)
                                              ]), 8, _hoisted_29)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.auth.can('BE') && props.row.sent == 1)
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                                              _createElementVNode("button", {
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.showModalRecieved(props.row))
                                              }, _cache[21] || (_cache[21] = [
                                                _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Détails ", -1)
                                              ]), 8, _hoisted_31)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.auth.can('BE') && props.row.sent == 0)
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                                              _createElementVNode("button", {
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.showModalRecieved(props.row))
                                              }, _cache[22] || (_cache[22] = [
                                                _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Détails ", -1)
                                              ]), 8, _hoisted_33)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (
                    _ctx.auth.can('BE') &&
                    props.row.parcels_num != 0 &&
                    props.row.sent == 0 &&
                    props.row.delivered == 0 &&
                    props.row.reception_agency != props.row.sending_agency
                  )
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
                                              _createElementVNode("button", {
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.transportBon(props.row))
                                              }, _cache[23] || (_cache[23] = [
                                                _createElementVNode("i", { class: "flaticon-express-delivery lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Expédier ", -1)
                                              ]), 8, _hoisted_35)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (
                    _ctx.auth.can('BE') &&
                    props.row.parcels_num != 0 &&
                    props.row.delivered == 0 &&
                    (props.row.sent == 1 ||
                      (props.row.sent == 0 &&
                        props.row.reception_agency == props.row.sending_agency))
                  )
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                                              _createElementVNode("button", {
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.distributionBon(props.row))
                                              }, _cache[24] || (_cache[24] = [
                                                _createElementVNode("i", { class: "flaticon-check lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Reçu ", -1)
                                              ]), 8, _hoisted_37)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (
                    _ctx.auth.can('BE') &&
                    props.row.parcels_num == 0 &&
                    props.row.delivered == 0 &&
                    props.row.sent == 0
                  )
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                                              _createElementVNode("button", {
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.removeNote(props.row))
                                              }, _cache[25] || (_cache[25] = [
                                                _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Supprimer ", -1)
                                              ]), 8, _hoisted_39)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("li", null, [
                                          (
                      _ctx.auth.can('BE') &&
                      props.row.delivered == 0 &&
                      props.row.sent == 0 &&
                      props.row.type_note == 'SIMPLE'
                    )
                                            ? (_openBlock(), _createBlock(_component_router_link, {
                                                key: 0,
                                                class: "dropdown-item d-flex align-items-center",
                                                to: {
                      name: 'EditSentNotePage',
                      params: {
                        id: props.row.id,
                        refNote: props.row.note_ref,
                      },
                    }
                                              }, {
                                                default: _withCtx(() => _cache[26] || (_cache[26] = [
                                                  _createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1),
                                                  _createTextVNode(" Modifier ", -1)
                                                ])),
                                                _: 2,
                                                __: [26]
                                              }, 1032, ["to"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("li", null, [
                                          (_ctx.auth.can('BE') && props.row.parcels_num != 0)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.getPDF(props.row))
                                              }, _cache[27] || (_cache[27] = [
                                                _createElementVNode("i", { class: "flaticon-printer lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" PDF ", -1)
                                              ]), 8, _hoisted_40))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("li", null, [
                                          (_ctx.auth.can('BE') && props.row.parcels_num != 0)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                class: "dropdown-item d-flex align-items-center",
                                                href: "javascript:void(0);",
                                                onClick: ($event: any) => (_ctx.ticketsPDF(props.row))
                                              }, _cache[28] || (_cache[28] = [
                                                _createElementVNode("i", { class: "flaticon-menu-1 lh-1 me-8 position-relative top-1" }, null, -1),
                                                _createTextVNode(" Tickets ", -1)
                                              ]), 8, _hoisted_41))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "loading", "onSelectAll", "onSelectedRowsChange"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.filters,
          offset: 9,
          onPaginate: _ctx.getRecords
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Détails du Bon"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _createVNode(_component_ShowEditBn, {
                  rowBE: _ctx.noteRow,
                  getRecords: _ctx.getRecords,
                  isOpen: _ctx.isOpen
                }, null, 8, ["rowBE", "getRecords", "isOpen"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_47, [
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Détails du Bon"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                (_ctx.noteRow && Object.keys(_ctx.noteRow).length != 0)
                  ? (_openBlock(), _createBlock(_component_EditSentNote2, {
                      key: 0,
                      rowBE: _ctx.noteRow,
                      getRecords: _ctx.getRecords,
                      type: true,
                      isOpen: _ctx.isOpen
                    }, null, 8, ["rowBE", "getRecords", "isOpen"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("h1", _hoisted_55, " Expedier le bon : " + _toDisplayString(_ctx.TransRow?.note_ref), 1),
            _cache[32] || (_cache[32] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("form", {
              onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.expedierBon(_ctx.TransRow.id)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _cache[33] || (_cache[33] = _createElementVNode("label", { for: "driver" }, "Transport", -1)),
                    _createVNode(_component_v_select, {
                      class: "custom-select-height",
                      options: _ctx.transportList,
                      modelValue: _ctx.transport,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.transport) = $event)),
                      label: "name"
                    }, null, 8, ["options", "modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _cache[34] || (_cache[34] = _createElementVNode("label", { for: "sacs" }, "Le nombre de sacs", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.sacs_transport) = $event)),
                      name: "sacs",
                      type: "number",
                      min: "0"
                    }, null, 512), [
                      [_vModelText, _ctx.sacs_transport]
                    ])
                  ])
                ]),
                (_ctx.transport?.type == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _cache[35] || (_cache[35] = _createElementVNode("label", { for: "code_transport" }, "Code d'envoie", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.code_transport) = $event)),
                          name: "name"
                        }, null, 512), [
                          [_vModelText, _ctx.code_transport]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_64, [
            _cache[36] || (_cache[36] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Fermer ", -1)),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.expedierBon(_ctx.TransRow.id))),
              class: "btn btn-primary"
            }, " Enregistrer ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_65, [
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("h1", _hoisted_69, " Reçu le bon : " + _toDisplayString(_ctx.TransRow?.note_ref), 1),
            _cache[37] || (_cache[37] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _cache[39] || (_cache[39] = _createElementVNode("label", { for: "driver" }, "Auto distribution", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.auto_distr) = $event))
                  }, _cache[38] || (_cache[38] = [
                    _createElementVNode("option", { value: "0" }, "Non", -1),
                    _createElementVNode("option", { value: "1" }, "Oui", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.auto_distr]
                  ])
                ])
              ]),
              (_ctx.auto_distr == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                    _cache[40] || (_cache[40] = _createElementVNode("label", { for: "driver" }, "Livreur", -1)),
                    _createElementVNode("div", _hoisted_75, [
                      _createVNode(_component_v_select, {
                        options: _ctx.livsZone,
                        modelValue: _ctx.livreur,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.livreur) = $event)),
                        label: "name"
                      }, null, 8, ["options", "modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_76, [
            _cache[41] || (_cache[41] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Fermer ", -1)),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.reçuBon(_ctx.TransRow.id))),
              class: "btn btn-primary"
            }, " Enregistrer ")
          ])
        ])
      ])
    ])
  ], 64))
}